/* eslint-disable sonarjs/no-nested-template-literals */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable sonarjs/cognitive-complexity */
import { Injectable, Inject } from '@angular/core';
import { CaAnalyticsService, authStatus } from '../ca-analytics.service';
// TODO: https://git.sys.cigna.com/angular-guild/cigna-nx/issues/567
import { LinkType } from '@cigna/shared/angular/analytics-data-access';
// TODO: https://git.sys.cigna.com/angular-guild/cigna-nx/issues/567
import {
  MouseTrackEvent,
  ValueTrackEvent,
} from '@cigna/shared/angular/analytics-ui';
import { RouteData, ServiceError } from '@cigna/cigna-for-brokers/shared/util';
import { LinkExtraData } from '../ca.rules';
import { DigitalDataObject } from './shell-track-handlers.model';
import { WindowService } from '@cigna/shared/angular/core/window-util';
import {
  formatProductString,
  ImpressionEventType,
  ImpressionType,
  ImpressionVariable,
} from '@cigna/shared/angular/analytics-util';
import { MD5 } from 'object-hash';
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { take } from 'rxjs/operators';
import { ProfileType } from '@cigna/cigna-for-brokers/shared/data-access';

const notLoggedIn = 'not logged in';
@Injectable({ providedIn: 'root' })
export class ShellTrackHandlers {
  pathName: string;
  isPublic: boolean;
  extraLocal?: LinkExtraData;
  agencyNames: string | undefined;
  partyRoles: string | undefined;
  peid: unknown;
  ssoId$ = this._appstateFacade.ssoId$;
  roles$ = this._appstateFacade.roles$;
  partyRole$ = this._appstateFacade.partyRole$;
  agencyName$ = this._appstateFacade.agencyName$;
  userProfile$ = this._appstateFacade.isProfileUser$;
  uniqueRoles = [...new Set()];
  eVar120: string | undefined;
  roles: string[] = [];
  roleIds: string[] = [];
  combinedRoles: string | undefined;

  currentSsoid = '';
  constructor(
    private _analytics: CaAnalyticsService,
    private _window: WindowService,
    public _appstateFacade: AppstateFacade,
    @Inject(`dontAllowAnalyticsForCurrentRls`)
    private dontAllowAnalyticsForCurrentRls?: string[],
  ) {
    this.pathName = this._window.location.pathname;
    this.isPublic = this.pathName.includes('public');
    this.ssoId$.pipe(take(3)).subscribe((res: string) => {
      if (res) {
        this.currentSsoid = res;
      }
    });
    this.partyRole$.pipe(take(3)).subscribe((res: string) => {
      if (res) {
        this.partyRoles = res;
      }
    });
    this.agencyName$.pipe(take(3)).subscribe((res: string) => {
      if (res) {
        this.agencyNames = res;
      }
    });
    this.userProfile$.pipe(take(3)).subscribe((res: ProfileType) => {
      if (res) {
        this.peid = res.accessTokenBody['cigna.userPeId'];
      }
    });
    this.roles$.pipe(take(3)).subscribe((resroles) => {
      if (resroles) {
        resroles.forEach((roleitem) => {
          this.roles.push(roleitem.lob);
          if (
            roleitem.roleId !== 'AAD' &&
            roleitem.roleId !== 'AC' &&
            roleitem.roleId !== 'PWA'
          ) {
            this.roleIds.push(roleitem.roleId);
          }
        });
        const noEmptyRoles = this.roles.sort().filter((v) => v.trim() !== '');
        this.uniqueRoles = [...new Set(noEmptyRoles)];
        const sortedRoleIds = this.roleIds.sort(
          (a, b) => parseInt(a, 10) - parseInt(b, 10),
        );

        const noDupRoleIds = [...new Set(sortedRoleIds)];

        if (this.partyRoles && noDupRoleIds.length === 0) {
          this.combinedRoles = `${this.partyRoles}`;
        } else if (this.partyRoles && noDupRoleIds.length > 0) {
          this.combinedRoles = `${this.partyRoles}^${noDupRoleIds.join('^')}`;
        } else {
          this.combinedRoles = `${noDupRoleIds.join('^')}`;
        }
      }
    });
  }
  updateStore(data: DigitalDataObject) {
    this._analytics.updateStore(data);
  }

  trackLogoutSuccess(data: { variation: string; linkName: string }) {
    this._analytics.trackEvent(
      'trackOther',
      {
        linkName: data.linkName,
        prop13: 'ac-US468654-Login Logout',
        eVar8: authStatus.loggedOut,
        events: 'event2',
        prop20: data.linkName === 'Logout' ? 'nav-sub-utility' : null,
      },
      LinkType.OTHER,
    );
    this._analytics.clearUserStore();
    localStorage.setItem('adobeLoginSuccess', 'n');
  }

  trackLoginSuccess() {
    const loginSuccessHistory =
      localStorage.getItem('adobeLoginSuccess') || 'n';

    if (loginSuccessHistory === 'n') {
      this._analytics.trackEvent(
        'trackOther',
        {
          linkName: 'Login Success',
          prop13: 'ac-US468654-Login Success',
          eVar8: authStatus.loggedIn,
          events: 'event1,event137',
          eVar98: this.peid,
          eVar101: this.agencyNames,
          eVar127: this.partyRoles,
        },
        LinkType.OTHER,
      );
      localStorage.setItem('adobeLoginSuccess', 'y');
    }
  }

  trackPageLoad(data: RouteData, _url: string | null) {
    if (data.analytics) {
      this._analytics.trackPage('caPageLoadTrack', {
        channel: data.analytics.section,
        pageName: this.isPublic
          ? `CFE${this.pathName.split('/').join(':')}`
          : data.analytics.name,
        hier1: this.isPublic
          ? // eslint-disable-next-line sonarjs/no-nested-template-literals
            `CFE|${data.analytics.section ? `${data.analytics.section}|` : ''}${
              data.analytics.name
            }`
          : undefined,
        eVar2: `CFE - ${data.analytics.section} ${data.analytics.name.replace(
          '|',
          ' ',
        )}`,
        prop13: data.analytics.prop13,
        eVar8: this.isPublic ? notLoggedIn : 'logged in',
        eVar119: data.analytics.eVar119,
        events: data.analytics.events,
      });
    }
  }

  /* use this only in extreme cases where page is not loaded from router, but we want to track as equivalent of a page view */
  trackPageLoadOnInit(
    event: TrackEvent,
    url: string,
    section: string,
    name: string,
    prop13: string,
    events?: string,
    userType?: string,
  ) {
    const pathName = this._window.location.pathname;
    this._analytics.trackPage('caPageLoadTrack', {
      prop13,
      events,
      channel: section,
      pageName: `CFE${pathName.split('/').join(':')}`,
      hier1: `CFE|${section ? `${section}|` : ''}${name}`,
      eVar2: `CFE - ${section} ${name ? name.replace('|', ' ') : ''}`,
      eVar8: notLoggedIn,
      eVar126: userType ? userType : '',
    });
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  trackPageLoadOnInitExtra(
    _event: TrackEvent,
    project: string,
    section: string,
    name: string,
    loggedInStatus: boolean,
    prop13: string,
    extra?: LinkExtraData,
  ) {
    const eVar119 = extra && extra['eVar119'] ? extra['eVar119'] : '';
    if (this.doTrack(eVar119)) {
      if (this.extraLocal) {
        this._analytics.trackSatellitePageViewEvent('pageView', {
          prop13,
          channel: section,
          pageName: this.isPublic
            ? `CFB${this.pathName.split('/').join(':')}`
            : name,
          hier1: this.isPublic
            ? `${project}|${section ? `${section}|` : ''}${name}`
            : undefined,
          eVar2: `${project} - ${section} ${
            name ? name.replace('|', ' ') : ''
          }`,
          eVar84: this.currentSsoid,
          eVar55:
            this.uniqueRoles.length > 1
              ? this.uniqueRoles.join('^')
              : this.uniqueRoles[0],
          eVar8: loggedInStatus ? 'logged in' : notLoggedIn,
          ...extra,
          ...this.extraLocal,
          eVar98: this.peid,
          eVar101: this.agencyNames,
          eVar127: this.partyRoles,
          eVar128: this.combinedRoles,
        });
      } else {
        this._analytics.trackSatellitePageViewEvent('pageView', {
          prop13,
          channel: section,
          pageName: this.isPublic
            ? `CFB${this.pathName.split('/').join(':')}`
            : name,
          hier1: this.isPublic
            ? `${project}|${section ? `${section}|` : ''}${name}`
            : undefined,
          eVar2: `${project} - ${section} ${
            name ? name.replace('|', ' ') : ''
          }`,
          eVar84: this.currentSsoid,
          eVar55:
            this.uniqueRoles.length > 1
              ? this.uniqueRoles.join('^')
              : this.uniqueRoles[0],
          eVar8: loggedInStatus ? 'logged in' : notLoggedIn,
          ...extra,
          eVar98: this.peid,
          eVar101: this.agencyNames,
          eVar127: this.partyRoles,
          eVar128: this.combinedRoles,
        });
      }

      if (extra && extra.eVar98) {
        this.extraLocal = {
          eVar14: extra.eVar14,
          eVar55: extra.eVar55,
          eVar98: extra.eVar98,
          eVar99: extra.eVar99,
          eVar154: extra.eVar154,
        };
      }
    }
  }

  // [cignaTrackClicks] and [cignaTrackInit] directives expect first param as the event
  // when calling this method outside a directive, such as from an effect pass {} for the event param
  trackEventOther(
    event: ValueTrackEvent<string> | any,
    linkName: string,
    prop13: string,
    extra?: LinkExtraData,
  ) {
    const loggedIn = 'logged in';

    if (extra && extra.eVar120) {
      this.eVar120 = extra.eVar120;
    }

    if (extra && extra.eVar98) {
      this.extraLocal = {
        eVar14: extra.eVar14,
        eVar55: extra.eVar55,
        eVar98: extra.eVar98,
        eVar99: extra.eVar99,
        eVar120: extra.eVar120,
        eVar154: extra.eVar154,
      };
    }
    if (this.extraLocal) {
      this._analytics.trackSatelliteClickEvent('trackOtherEvent', {
        linkName,
        prop13,
        eVar14: this.extraLocal.eVar14,
        eVar55:
          this.uniqueRoles.length > 1
            ? this.uniqueRoles.join('^')
            : this.uniqueRoles[0],
        // eVar98: this.extraLocal.eVar98,
        eVar99: this.extraLocal.eVar99,
        eVar154: this.extraLocal.eVar154,
        eVar84: this.currentSsoid,
        eVar8: prop13 === 'acCFBSU001' ? notLoggedIn : loggedIn,
        eVar2: `CFB - ${extra?.channel} ${extra?.pageName}`,
        channel: extra?.channel,
        pageName: extra?.pageName,
        eVar98: this.peid,
        eVar101: this.agencyNames,
        eVar120: this.extraLocal.eVar120,
        eVar127: this.partyRoles,
        eVar128: this.combinedRoles,
        ...extra,
      });
    } else {
      this._analytics.trackSatelliteClickEvent('trackOtherEvent', {
        linkName,
        prop13,
        eVar84: this.currentSsoid,
        eVar55:
          this.uniqueRoles.length > 1
            ? this.uniqueRoles.join('^')
            : this.uniqueRoles[0],
        channel: extra?.channel,
        pageName: extra?.pageName,
        eVar8: prop13 === 'acCFBSU001' ? notLoggedIn : loggedIn,
        eVar2: `CFB - ${extra?.channel} ${extra?.pageName}`,
        eVar98: this.peid,
        eVar101: this.agencyNames,
        eVar120: this.eVar120,
        eVar127: this.partyRoles,
        eVar128: this.combinedRoles,
        ...extra,
      });
    }
  }

  // todo: make eVar12 a required param, or try to auto generate it, eVar12 = linkName:[URL]
  trackEventExit(
    event: MouseTrackEvent,
    linkName: string,
    prop13: string,
    extra?: LinkExtraData,
  ) {
    const target = event.mouseEvent.currentTarget as HTMLLinkElement;
    const eVar12 = `${linkName}:${target.href}`;
    this._analytics.trackEvent(
      'trackOther',
      { linkName, prop13, eVar12, prop12: 'D=v12', ...extra },
      LinkType.EXIT,
    );
  }

  trackEventDownload(
    event: MouseTrackEvent,
    linkName: string,
    prop13: string,
    extra?: LinkExtraData,
  ) {
    const target = event.mouseEvent.currentTarget as HTMLLinkElement;
    const prop7 = `${linkName}:${target.href}`;
    const extraEvents = extra && extra.events;
    this._analytics.trackEvent(
      'trackOther',
      {
        ...extra,
        linkName,
        prop13,
        prop7,
        events: extraEvents ? `${extraEvents},event8` : 'event8',
      },
      LinkType.DOWNLOAD,
    );
  }

  // [cignaTrackInit] directive expect first param as the event
  // when calling this method outside the directive, such as from an effect pass {} for the event param
  trackServiceError(
    event: any,
    serviceName: string,
    error: ServiceError,
    customerMessage: string,
    additionalEvents?: string,
  ) {
    this._analytics.trackEvent(
      'trackOther',
      {
        prop13: 'ac-Error001',
        linkName: customerMessage,
        prop37: `Service Err^${serviceName}^${error.status?.toString()}^${error.message?.replace(
          /[,;]/g,
          '',
        )}^${customerMessage}`,
        events: `event291${additionalEvents ? `,${additionalEvents}` : ''}`,
      },
      LinkType.OTHER,
    );
  }
  // Impression Error Tracking
  trackErrorImpression(
    _event: TrackEvent,
    productParams: Array<{
      message: string;
      errorCode: number;
      isValidationError: boolean;
      validatedFieldLabel?: string;
      eVar119?: string;
    }>,
    extra?: LinkExtraData,
  ) {
    const eVar119 =
      productParams[0] && productParams[0]['eVar119']
        ? productParams[0]['eVar119']
        : '';
    if (this.doTrack(eVar119)) {
      const products = productParams
        .map(this.formatImpressionErrorProductString)
        .join(',');
      this._analytics.trackSatelliteErrorImpressionEvent(
        'trackOtherEvent',
        {
          products,
          prop13: 'im24424',
          prop67: 'impression',
          linkName: 'impression',
          eVar119,
          ...extra,
        },
        LinkType.OTHER,
      );
    }
  }
  formatImpressionErrorProductString = (
    params: {
      message: string;
      errorCode: number;
      isValidationError: boolean;
      validatedFieldLabel?: string;
    },
    i: number,
  ) =>
    formatProductString({
      impressionVariable: ImpressionVariable.EVAR110,
      impressionType: ImpressionType.PAGE_FEATURE,
      impressionEventType: ImpressionEventType.DISPLAYED,
      slots: [
        'error-message',
        params.errorCode,
        params.isValidationError ? 'validation error' : 'service error',
        params.validatedFieldLabel || '',
        MD5(params.message),
        params.message.substring(0, 100),
      ],
    });

  doTrack(eVar119: string) {
    return (
      eVar119 &&
      (!this.dontAllowAnalyticsForCurrentRls ||
        this.dontAllowAnalyticsForCurrentRls.indexOf(eVar119) === -1)
    );
  }
}
